import jp from "jsonpath"


/**
 * Finds the study time from TonP based on the category
 * @param tonp 
 * @param category 
 * @returns 
 */
export function getFlashcardsCategoricalStudyTimeInSeconds(tonp, category: string): number {
    let selectedJP = jp.query(tonp, `$..flashcards.stats.${category}.timeStudied`)
    let timeInSec = selectedJP.reduce((acc, cur) => acc + cur, 0)
    return timeInSec
}

/**
 * Finds the # of times card viewed from TonP based on the category
 * @param tonp 
 * @param category 
 * @returns 
 */
export function getFlashcardsCategoricalTotalCardsViewed(tonp, category: string): number {
    let selectedJP = jp.query(tonp, `$..flashcards.stats.${category}.nofCardsViewed`)
    let nofTotalCardsViewed = selectedJP.reduce((acc, cur) => acc + cur, 0)
    return nofTotalCardsViewed
}

/**
 * Finds the study time from TonP
 * @param tonp 
 * @returns 
 */
export function getFlashcardsTotalStudyTimeInSeconds(tonp): number {
    let selectedJP = jp.query(tonp, "$..flashcards.stats..timeStudied")
    let timeInSec = selectedJP.reduce((acc, cur) => acc + cur, 0)
    return timeInSec
}

/**
 * Finds the # of total cards viewed time from TonP
 * @param tonp 
 * @returns 
 */
export function getFlashcardsTotalCardsViewed(tonp): number {
    let selectedJP = jp.query(tonp, "$..flashcards.stats..nofCardsViewed")
    let nofTotalCardsViewed = selectedJP.reduce((acc, cur) => acc + cur, 0)
    return nofTotalCardsViewed
}

